import { USER_PROFILE_LOADED, USER_PROFILE_LOADING, LOGIN_REQUIRED,
  SIGN_IN_ATTEMPT,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_OUT_SUCCESS,
  SIGN_IN
} from '../actions';

const authReducer = (previousState = {}, action) => {
  switch (action.type) {
    case SIGN_IN:
    case SIGN_IN_ATTEMPT:
      return {
        ...previousState,
        isLoggingIn: true,
        isLoggedIn: false
      }
    case SIGN_IN_SUCCESS:
      return {
        ...previousState,
        user: action.user,
        accessToken: action.accessToken,
        isLoggingIn: false,
        isLoggedIn: true
      };
    case SIGN_IN_FAILURE:
      return {
        ...previousState,
        silentFailure: action.silent,
        isLoggingIn: false,
        isLoggedIn: false
      }
    case SIGN_OUT_SUCCESS:
      return {
        ...previousState,
        user: null,
        isLoggedIn: false
      }
    //case CRUD_UPDATE_SUCCESS:
      /*// Check if the user or profile has updated
      let user = previousState.user;
      // This is really tied to the resource objects in OOTB Imminently. Need to consider alternatives. 
      if (action.meta.resource === 'profiles' && action.payload.data.id === previousState.user.profile.id) {
        // They updated the profile of the authenticated user
        user.profile = action.payload.data;
      } else if (action.meta.resource === 'users' && action.payload.data.id === previousState.user.id) {
        user = action.payload.data;
      }
      return {
        ...previousState,
        user: user
      }*/
    /*case USER_PROFILE_LOADING:
      return {
        ...previousState,
        isLoggingIn: true,
      };
    case LOGIN_REQUIRED:
      return {
        ...previousState,
        loginRequired: true,
        isLoggingIn: false,
      };
    case USER_PROFILE_LOADED:
      return {
        ...previousState,
        user: action.user,
        profile: action.user.profile,
        isLoggingIn: false,
        isLoggedIn: true,
        loginRequired: false,
      };*/
    default:
      return previousState;
  }
};
export default authReducer;
